
const palette = {
    primary: {
      main: '#c942b1', 
      light: '#63a4ff', 
      dark: '#004ba0', 
      contrastText: '#ffffff', 
    },
    secondary: {
      main: '#7042c9', 
      light: '#ff5c8d', 
      dark: '#9a0036', 
      contrastText: '#ffffff', 
    },
    background: {
      default: '#fafafa', 
      paper: '#ffffff', 
    },
    text: {
      primary: '#000000', 
      secondary: '#757575', 
    },
    error: {
      main: '#d32f2f', 
    },
    warning: {
      main: '#ff9800', 
    },
    info: {
      main: '#2196f3', 
    },
    success: {
      main: '#4caf50', 
    },
    action: {
      active: '#1976d2',
      hover: '#ddd', 
    },
  };
  
  export default palette;
  